
/**
 * Helper
 */
var helper = require('../../helper');

$(function() {
    var $datatable = $('#datatable-all-tickets-of-contractor'),
            $contractorId = $datatable.data('contractor'),
        dataTables_buttons = [
            {
                extend: 'colvis'
            }
        ];

    var table = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": helper.getOrigin() + "/api/tickets/contractor/" + $contractorId,
        "autoWidth" : false,
        "buttons": dataTables_buttons,
        "order": [[ 0, "desc" ]],
        "columns": [
            {data: 'ticket_id', name: 'id'},
            {data: 'status', name: 'status.name'},
            {data: 'urgency', name: 'urgency.name'},
            {data: 'property_id', name: 'property.property_id', visible: false},
            {data: 'property_name', name: 'property.name'},
            {data: 'postcode', name: 'property.postcode'},
            {data: 'created_at', name: 'created_at'},
            {data: 'date_estimated_completion', name: 'date_estimated_completion'},
            {data: 'date_completed', name: 'date_completed'},
            {data: 'job_type', name: 'type.name'},
            {data: 'contact_first_name', name: 'user.first_name'},
            {data: 'contact_last_name', name: 'user.last_name'},
            {data: 'contractor', name: 'contractor.name'},
            {data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action hidden-print", width: '60px'}
        ]
    });

    $('div[id^="searchDiv_"]').on("click", function () {
        var status_id = this.id.substring(10, this.id.length);
        if (status_id == 1)
            table.search( 'New' ).draw();
        if (status_id == 2)
            table.search( 'Live' ).draw();
        if (status_id == 3)
            table.search( 'Pending' ).draw();
        if (status_id == 4)
            table.search( 'Request' ).draw();
        if (status_id == 5)
            table.search( 'Completed' ).draw();
        if (status_id == 6)
            table.search( 'Declined' ).draw();
    });

    $('#clear-filer').on('click', function() {
        $('#datatable-all-tickets_filter input').val('');
        table.search( '' ).draw();
    });

});
